import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { Providers } from './providers'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Providers />
    </QueryClientProvider>
  )
}
